module.exports = __webpack_public_path__ + "static/img/b-bg.f5136ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/m/b-bg.png
// module id = C+jh
// module chunks = 0